import { Component, inject, input } from '@angular/core';
import { environment } from '@environment';
import { LoggingService } from '@services';

@Component({
  selector: 'bo-progress-bar',
  templateUrl: './progress-bar.component.html',
  standalone: true,
  imports: [],
})
export class ProgressBarComponent {
  progress = input<number>();

  protected loggingService = inject(LoggingService);

  environment = environment;
}
